import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MandateHomeComponent } from './mandate-home/mandate-home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { LocalStorageModule } from 'angular-2-local-storage';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HttpModule } from '@angular/http';
import { GenericlinkComponent } from './genericlink/genericlink.component';
import { RazorPayThankyouComponent } from './RazorpayResponsePage/razor-pay-thankyou/razor-pay-thankyou.component';
import { RazorPayFailureComponent } from './RazorpayResponsePage/razor-pay-failure/razor-pay-failure.component';
import { ShortenedJourneryComponent } from './shortened-journery/shortened-journery.component';
import { SachetJourneyComponent } from './sachet-journey/sachet-journey.component';
@NgModule({
  declarations: [
    AppComponent,
    MandateHomeComponent,
    GenericlinkComponent,
    RazorPayThankyouComponent,
    RazorPayFailureComponent,
    ShortenedJourneryComponent,
    SachetJourneyComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(), 
    HttpClientModule,
    HttpModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      closeButton:true,
    }) ,// ToastrModule added
    LocalStorageModule.forRoot({
      prefix: 'my-app',
      storageType: 'localStorage'
  }), ModalModule.forRoot()
  
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
